module.exports = __webpack_public_path__ + "static/media/recordicon.6a85653a.svg";